<template>
  <div class="fan">
    <Card>
      <h2>页面开发中</h2>
      <p>该页面正在开发中，敬请期待！</p>
    </Card>
  </div>
</template>

<script>
  export default {
    name: 'block'
  }
</script>

<style scoped>
.fan{
    width: 100%; height: 100%;
    padding: 20px;
  }
</style>
